/* export function handleError(commit, error) {
    if (error.code === 'ECONNABORTED' || error.name === 'CanceledError') {
        console.log('Request canceled:', error.config?.url);
        return;
    }
    commit('hideModalWorking');
    commit('showModal', { component: 'ModalError', data: "Napaka v povezavi. Prosimo, poskusite ponovno." });
} */

export function handleError(commit, error) {
    // 1) Explicit cancel
    if (error.name === 'CanceledError') return;
  
    // 2) Timeout (Axios sets code, but be defensive)
    if (error.code === 'ECONNABORTED' || /timeout/i.test(error.message)) {
      //commit('hideModalWorking');
      //commit('showModal', { component: 'ModalError', data: "Zahteva je potekla (timeout). Poskusite ponovno." });
      return;
    }
  
    const status = error.response?.status;
    const url = error.config?.url;
    console.error('AXIOS ERROR', { url, status, message: error.message, code: error.code, data: error.response?.data });
  
    commit('hideModalWorking');
  
    if (status) {
      // Server responded but with non-2xx
      commit('showModal', { component: 'ModalError', data: `Napaka strežnika (${status}). Poskusite ponovno.` });
    } else {
      // No response received (connection reset, CORS, offline, proxy)
      commit('showModal', { component: 'ModalError', data: "Napaka v povezavi. Prosimo, poskusite ponovno." });
    }
  }